import React from 'react'
import { connect } from 'react-redux'
import { updateMovie } from '../actions/movies'
import { MovieUlStyled, MovieLiStyled } from './dataDisplay.styles'

const Movie = ({ id, title, releaseYear, notes, movieFilter, updateMovie }) => {
  let textInput = React.createRef()

  function handleKeyPress(event) {
    if(event.key === 'Enter'){
      updateMovie({id: id, notes: textInput.current.value})
      textInput.current.value = ''
    }
  }

  let showTitle = false
  let showReleaseYear = false
  let showNotes = false

  movieFilter.map(movieFilterItem => {
    showTitle = (movieFilterItem.key === 'title' ? movieFilterItem.value : showTitle)
    showReleaseYear = (movieFilterItem.key === 'releaseYear' ? movieFilterItem.value : showReleaseYear)
    showNotes = (movieFilterItem.key === 'notes' ? movieFilterItem.value : showNotes)
  })

  return (
    <MovieUlStyled>
      {showTitle && <MovieLiStyled>{title}</MovieLiStyled>}
      {showReleaseYear && <MovieLiStyled>{releaseYear}</MovieLiStyled>}
      {showNotes && <MovieLiStyled>Notes:</MovieLiStyled>}
      {showNotes && <MovieLiStyled>
        <ul>
          {notes.map((note, index) =>
            <li key={index}>{note}</li>
          )}
        </ul>
      </MovieLiStyled>
      }
      {showNotes && <MovieLiStyled><textarea type='text' ref={textInput} placeholder='Add a note here...' onKeyPress={handleKeyPress}></textarea></MovieLiStyled>}
    </MovieUlStyled>
  )
}

export default connect(({ movies }) =>
  ({
    movieFilter: movies.movieFilter
  }), { updateMovie })(Movie)



// WEBPACK FOOTER //
// ./src/components/movie.js